import { render, staticRenderFns } from "./FinancialDimensionSettings.vue?vue&type=template&id=6e1b9157"
import script from "./FinancialDimensionSettings.vue?vue&type=script&lang=js"
export * from "./FinancialDimensionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports